import { Platform as Ft } from "react-native-web";
import { jsx as Fe } from "react/jsx-runtime";
import * as x from "react";
import ft, { PureComponent as Ut } from "react";
function W() {
  return W = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W.apply(null, arguments);
}
var j;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(j || (j = {}));
var ie = process.env.NODE_ENV !== "production" ? function(e) {
  return Object.freeze(e);
} : function(e) {
  return e;
};
function te(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
var Ue = "beforeunload", Ht = "popstate";
function Bt(e) {
  e === void 0 && (e = {});
  var t = e, r = t.window, n = r === void 0 ? document.defaultView : r, o = n.history;
  function s() {
    var w = n.location, N = w.pathname, S = w.search, R = w.hash, A = o.state || {};
    return [A.idx, ie({
      pathname: N,
      search: S,
      hash: R,
      state: A.usr || null,
      key: A.key || "default"
    })];
  }
  var i = null;
  function a() {
    if (i)
      h.call(i), i = null;
    else {
      var w = j.Pop, N = s(), S = N[0], R = N[1];
      if (h.length)
        if (S != null) {
          var A = c - S;
          A && (i = {
            action: w,
            location: R,
            retry: function() {
              g(A * -1);
            }
          }, g(A));
        } else
          process.env.NODE_ENV !== "production" && te(
            !1,
            // TODO: Write up a doc that explains our blocking strategy in
            // detail and link to it here so people can understand better what
            // is going on and how to avoid it.
            "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation."
          );
      else
        d(w);
    }
  }
  n.addEventListener(Ht, a);
  var u = j.Pop, f = s(), c = f[0], l = f[1], m = se(), h = se();
  c == null && (c = 0, o.replaceState(W({}, o.state, {
    idx: c
  }), ""));
  function _(w) {
    return typeof w == "string" ? w : lt(w);
  }
  function O(w, N) {
    return N === void 0 && (N = null), ie(W({
      pathname: l.pathname,
      hash: "",
      search: ""
    }, typeof w == "string" ? Oe(w) : w, {
      state: N,
      key: _e()
    }));
  }
  function b(w, N) {
    return [{
      usr: w.state,
      key: w.key,
      idx: N
    }, _(w)];
  }
  function v(w, N, S) {
    return !h.length || (h.call({
      action: w,
      location: N,
      retry: S
    }), !1);
  }
  function d(w) {
    u = w;
    var N = s();
    c = N[0], l = N[1], m.call({
      action: u,
      location: l
    });
  }
  function p(w, N) {
    var S = j.Push, R = O(w, N);
    function A() {
      p(w, N);
    }
    if (v(S, R, A)) {
      var B = b(R, c + 1), ye = B[0], Q = B[1];
      try {
        o.pushState(ye, "", Q);
      } catch {
        n.location.assign(Q);
      }
      d(S);
    }
  }
  function y(w, N) {
    var S = j.Replace, R = O(w, N);
    function A() {
      y(w, N);
    }
    if (v(S, R, A)) {
      var B = b(R, c), ye = B[0], Q = B[1];
      o.replaceState(ye, "", Q), d(S);
    }
  }
  function g(w) {
    o.go(w);
  }
  var E = {
    get action() {
      return u;
    },
    get location() {
      return l;
    },
    createHref: _,
    push: p,
    replace: y,
    go: g,
    back: function() {
      g(-1);
    },
    forward: function() {
      g(1);
    },
    listen: function(N) {
      return m.push(N);
    },
    block: function(N) {
      var S = h.push(N);
      return h.length === 1 && n.addEventListener(Ue, Be), function() {
        S(), h.length || n.removeEventListener(Ue, Be);
      };
    }
  };
  return E;
}
function Wt(e) {
  e === void 0 && (e = {});
  var t = e, r = t.initialEntries, n = r === void 0 ? ["/"] : r, o = t.initialIndex, s = n.map(function(p) {
    var y = ie(W({
      pathname: "/",
      search: "",
      hash: "",
      state: null,
      key: _e()
    }, typeof p == "string" ? Oe(p) : p));
    return process.env.NODE_ENV !== "production" && te(y.pathname.charAt(0) === "/", "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(p) + ")"), y;
  }), i = He(o ?? s.length - 1, 0, s.length - 1), a = j.Pop, u = s[i], f = se(), c = se();
  function l(p) {
    return typeof p == "string" ? p : lt(p);
  }
  function m(p, y) {
    return y === void 0 && (y = null), ie(W({
      pathname: u.pathname,
      search: "",
      hash: ""
    }, typeof p == "string" ? Oe(p) : p, {
      state: y,
      key: _e()
    }));
  }
  function h(p, y, g) {
    return !c.length || (c.call({
      action: p,
      location: y,
      retry: g
    }), !1);
  }
  function _(p, y) {
    a = p, u = y, f.call({
      action: a,
      location: u
    });
  }
  function O(p, y) {
    var g = j.Push, E = m(p, y);
    function w() {
      O(p, y);
    }
    process.env.NODE_ENV !== "production" && te(u.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.push(" + JSON.stringify(p) + ")"), h(g, E, w) && (i += 1, s.splice(i, s.length, E), _(g, E));
  }
  function b(p, y) {
    var g = j.Replace, E = m(p, y);
    function w() {
      b(p, y);
    }
    process.env.NODE_ENV !== "production" && te(u.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(p) + ")"), h(g, E, w) && (s[i] = E, _(g, E));
  }
  function v(p) {
    var y = He(i + p, 0, s.length - 1), g = j.Pop, E = s[y];
    function w() {
      v(p);
    }
    h(g, E, w) && (i = y, _(g, E));
  }
  var d = {
    get index() {
      return i;
    },
    get action() {
      return a;
    },
    get location() {
      return u;
    },
    createHref: l,
    push: O,
    replace: b,
    go: v,
    back: function() {
      v(-1);
    },
    forward: function() {
      v(1);
    },
    listen: function(y) {
      return f.push(y);
    },
    block: function(y) {
      return c.push(y);
    }
  };
  return d;
}
function He(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function Be(e) {
  e.preventDefault(), e.returnValue = "";
}
function se() {
  var e = [];
  return {
    get length() {
      return e.length;
    },
    push: function(r) {
      return e.push(r), function() {
        e = e.filter(function(n) {
          return n !== r;
        });
      };
    },
    call: function(r) {
      e.forEach(function(n) {
        return n && n(r);
      });
    }
  };
}
function _e() {
  return Math.random().toString(36).substr(2, 8);
}
function lt(e) {
  var t = e.pathname, r = t === void 0 ? "/" : t, n = e.search, o = n === void 0 ? "" : n, s = e.hash, i = s === void 0 ? "" : s;
  return o && o !== "?" && (r += o.charAt(0) === "?" ? o : "?" + o), i && i !== "#" && (r += i.charAt(0) === "#" ? i : "#" + i), r;
}
function Oe(e) {
  var t = {};
  if (e) {
    var r = e.indexOf("#");
    r >= 0 && (t.hash = e.substr(r), e = e.substr(0, r));
    var n = e.indexOf("?");
    n >= 0 && (t.search = e.substr(n), e = e.substr(0, n)), e && (t.pathname = e);
  }
  return t;
}
const dt = "@@router/CALL_HISTORY_METHOD", pt = "@@router/LOCATION_CHANGE", me = (e, t) => ({
  type: pt,
  payload: { location: e, action: t }
});
function H(e) {
  return (...t) => ({
    type: dt,
    payload: { method: e, args: t }
  });
}
const Kt = H("push"), Gt = H("replace"), Yt = H("go"), qt = H("goBack"), Jt = H("goForward"), Xt = H("back"), Qt = H("forward");
function We(e, t) {
  return typeof e == "string" && !e.startsWith(t) ? t + e : typeof e == "object" && e.pathname && !e.pathname.startsWith(t) ? Object.assign(Object.assign({}, e), { pathname: t + e.pathname }) : e;
}
const Zt = ({ history: e, showHistoryAction: t, basename: r }) => () => (
  // @ts-ignore
  (n) => (o) => {
    if (o.type !== dt)
      return n(o);
    const s = o.payload.method, i = o.payload.args;
    switch (s) {
      case "push": {
        let a = i;
        r && i.length > 0 && (a = [
          We(i[0], r),
          ...i.slice(1)
        ]), e.push(...a);
        break;
      }
      case "replace": {
        let a = i;
        r && i.length > 0 && (a = [
          We(i[0], r),
          ...i.slice(1)
        ]), e.replace(...a);
        break;
      }
      case "go":
        e.go(...i);
        break;
      case "back":
      case "goBack":
        e.goBack && e.goBack(...i), e.back && e.back(...i);
        break;
      case "forward":
      case "goForward":
        e.goForward && e.goForward(...i), e.forward && e.forward(...i);
        break;
    }
    if (t)
      return n(o);
  }
), er = ({ savePreviousLocations: e = 0, basename: t }) => {
  const r = {
    location: null,
    action: null,
    basename: t
  }, n = isNaN(e) ? 0 : e;
  return n && (r.previousLocations = []), (o = r, { type: s, payload: i } = {}) => {
    if (s === pt) {
      const { location: a, action: u } = i || {}, f = n ? [{ location: a, action: u }, ...o.previousLocations.slice(0, n)] : void 0;
      return Object.assign(Object.assign({}, o), { location: a, action: u, previousLocations: f });
    }
    return o;
  };
}, tr = ({ history: e, routerReducerKey: t = "router", reduxTravelling: r = !1, showHistoryAction: n = !1, selectRouterState: o, savePreviousLocations: s = 0, batch: i, reachGlobalHistory: a, basename: u }) => {
  let f = !1;
  const c = (b, v, d) => f ? b({ location: v, action: d }) : b(v, d);
  typeof i != "function" && (i = (b) => {
    b();
  }), typeof o != "function" && (o = (b) => b[t]);
  const l = er({ savePreviousLocations: s, basename: u }), m = Zt({ history: e, showHistoryAction: n, basename: u });
  let h = !1;
  const _ = (b) => {
    const v = (d, p) => d.pathname === p.pathname && d.search === p.search && d.hash === p.hash;
    return b.subscribe(() => {
      const d = o(b.getState()).location, p = e.location;
      d && p && !v(d, p) && (h = !0, e.push({ pathname: d.pathname, search: d.search, hash: d.hash }));
    });
  };
  return { routerReducer: l, routerMiddleware: m, createReduxHistory: (b) => {
    let v = [];
    return b.dispatch(me(e.location, e.action)), r && _(b), e.listen((d, p) => {
      if (d.location && (p = d.action, d = d.location, f = !0), h) {
        h = !1;
        const y = o(b.getState());
        v.forEach((g) => c(g, y.location, y.action));
        return;
      }
      i(() => {
        b.dispatch(me(d, p));
        const y = o(b.getState());
        v.forEach((g) => c(g, y.location, y.action));
      });
    }), a && a.listen(({ location: d, action: p }) => {
      if (p !== "POP") {
        const y = {
          pathname: d.pathname,
          search: d.search,
          hash: d.hash,
          key: d.key,
          state: d.state
        };
        i(() => {
          b.dispatch(me(y, p));
          const g = o(b.getState());
          v.forEach((E) => c(E, g.location, g.action));
        });
      }
    }), {
      block: e.block,
      createHref: e.createHref,
      push: (...d) => b.dispatch(Kt(...d)),
      replace: (...d) => b.dispatch(Gt(...d)),
      go: (...d) => b.dispatch(Yt(...d)),
      // @ts-ignore
      goBack: (...d) => b.dispatch(qt(...d)),
      // @ts-ignore
      goForward: (...d) => (
        // @ts-ignore
        b.dispatch(Jt(...d))
      ),
      // @ts-ignore
      back: (...d) => b.dispatch(Xt(...d)),
      // @ts-ignore
      forward: (...d) => b.dispatch(Qt(...d)),
      listen: (d) => (v.indexOf(d) < 0 && v.push(d), () => {
        v = v.filter((p) => p !== d);
      }),
      // @ts-ignore
      get location() {
        return o(b.getState()).location;
      },
      // @ts-ignore
      get action() {
        return o(b.getState()).action;
      },
      get length() {
        return e.length;
      },
      // @ts-ignore
      get listenObject() {
        return f;
      }
    };
  } };
}, rr = void 0;
let ht;
const yt = tr({
  batch: rr,
  reduxTravelling: !0,
  history: Ft.OS === "web" ? Bt() : Wt()
}), nr = (e) => {
  ht = yt.createReduxHistory(e);
}, Yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  context: yt,
  init: nr,
  get state() {
    return ht;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Ne = { exports: {} }, be = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ke;
function or() {
  if (Ke) return be;
  Ke = 1;
  var e = ft;
  function t(u, f) {
    return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, o = e.useRef, s = e.useEffect, i = e.useMemo, a = e.useDebugValue;
  return be.useSyncExternalStoreWithSelector = function(u, f, c, l, m) {
    var h = o(null);
    if (h.current === null) {
      var _ = { hasValue: !1, value: null };
      h.current = _;
    } else _ = h.current;
    h = i(
      function() {
        function b(g) {
          if (!v) {
            if (v = !0, d = g, g = l(g), m !== void 0 && _.hasValue) {
              var E = _.value;
              if (m(E, g))
                return p = E;
            }
            return p = g;
          }
          if (E = p, r(d, g)) return E;
          var w = l(g);
          return m !== void 0 && m(E, w) ? (d = g, E) : (d = g, p = w);
        }
        var v = !1, d, p, y = c === void 0 ? null : c;
        return [
          function() {
            return b(f());
          },
          y === null ? void 0 : function() {
            return b(y());
          }
        ];
      },
      [f, c, l, m]
    );
    var O = n(u, h[0], h[1]);
    return s(
      function() {
        _.hasValue = !0, _.value = O;
      },
      [O]
    ), a(O), O;
  }, be;
}
var ge = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ge;
function ir() {
  return Ge || (Ge = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = ft, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, o = t.useRef, s = t.useEffect, i = t.useMemo, a = t.useDebugValue;
    ge.useSyncExternalStoreWithSelector = function(u, f, c, l, m) {
      var h = o(null);
      if (h.current === null) {
        var _ = { hasValue: !1, value: null };
        h.current = _;
      } else _ = h.current;
      h = i(
        function() {
          function b(g) {
            if (!v) {
              if (v = !0, d = g, g = l(g), m !== void 0 && _.hasValue) {
                var E = _.value;
                if (m(E, g))
                  return p = E;
              }
              return p = g;
            }
            if (E = p, r(d, g))
              return E;
            var w = l(g);
            return m !== void 0 && m(E, w) ? (d = g, E) : (d = g, p = w);
          }
          var v = !1, d, p, y = c === void 0 ? null : c;
          return [
            function() {
              return b(f());
            },
            y === null ? void 0 : function() {
              return b(y());
            }
          ];
        },
        [f, c, l, m]
      );
      var O = n(u, h[0], h[1]);
      return s(
        function() {
          _.hasValue = !0, _.value = O;
        },
        [O]
      ), a(O), O;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ge;
}
process.env.NODE_ENV === "production" ? Ne.exports = or() : Ne.exports = ir();
var sr = Ne.exports;
function ar(e) {
  e();
}
function ur() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      ar(() => {
        let r = e;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      const r = [];
      let n = e;
      for (; n; )
        r.push(n), n = n.next;
      return r;
    },
    subscribe(r) {
      let n = !0;
      const o = t = {
        callback: r,
        next: null,
        prev: t
      };
      return o.prev ? o.prev.next = o : e = o, function() {
        !n || e === null || (n = !1, o.next ? o.next.prev = o.prev : t = o.prev, o.prev ? o.prev.next = o.next : e = o.next);
      };
    }
  };
}
var Ye = {
  notify() {
  },
  get: () => []
};
function cr(e, t) {
  let r, n = Ye, o = 0, s = !1;
  function i(O) {
    c();
    const b = n.subscribe(O);
    let v = !1;
    return () => {
      v || (v = !0, b(), l());
    };
  }
  function a() {
    n.notify();
  }
  function u() {
    _.onStateChange && _.onStateChange();
  }
  function f() {
    return s;
  }
  function c() {
    o++, r || (r = e.subscribe(u), n = ur());
  }
  function l() {
    o--, r && o === 0 && (r(), r = void 0, n.clear(), n = Ye);
  }
  function m() {
    s || (s = !0, c());
  }
  function h() {
    s && (s = !1, l());
  }
  const _ = {
    addNestedSub: i,
    notifyNestedSubs: a,
    handleChangeWrapper: u,
    isSubscribed: f,
    trySubscribe: m,
    tryUnsubscribe: h,
    getListeners: () => n
  };
  return _;
}
var fr = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", lr = /* @__PURE__ */ fr(), dr = () => typeof navigator < "u" && navigator.product === "ReactNative", pr = /* @__PURE__ */ dr(), hr = () => lr || pr ? x.useLayoutEffect : x.useEffect, yr = /* @__PURE__ */ hr(), mr = /* @__PURE__ */ Symbol.for("react-redux-context"), br = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function gr() {
  if (!x.createContext) return {};
  const e = br[mr] ??= /* @__PURE__ */ new Map();
  let t = e.get(x.createContext);
  return t || (t = x.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(x.createContext, t)), t;
}
var z = /* @__PURE__ */ gr();
function wr(e) {
  const { children: t, context: r, serverState: n, store: o } = e, s = x.useMemo(() => {
    const u = cr(o), f = {
      store: o,
      subscription: u,
      getServerState: n ? () => n : void 0
    };
    if (process.env.NODE_ENV === "production")
      return f;
    {
      const { identityFunctionCheck: c = "once", stabilityCheck: l = "once" } = e;
      return /* @__PURE__ */ Object.assign(f, {
        stabilityCheck: l,
        identityFunctionCheck: c
      });
    }
  }, [o, n]), i = x.useMemo(() => o.getState(), [o]);
  yr(() => {
    const { subscription: u } = s;
    return u.onStateChange = u.notifyNestedSubs, u.trySubscribe(), i !== o.getState() && u.notifyNestedSubs(), () => {
      u.tryUnsubscribe(), u.onStateChange = void 0;
    };
  }, [s, i]);
  const a = r || z;
  return /* @__PURE__ */ x.createElement(a.Provider, { value: s }, t);
}
var Er = wr;
function Ve(e = z) {
  return function() {
    const r = x.useContext(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var mt = /* @__PURE__ */ Ve();
function bt(e = z) {
  const t = e === z ? mt : (
    // @ts-ignore
    Ve(e)
  ), r = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var vr = /* @__PURE__ */ bt();
function _r(e = z) {
  const t = e === z ? vr : bt(e), r = () => t().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var qn = /* @__PURE__ */ _r(), Or = (e, t) => e === t;
function Nr(e = z) {
  const t = e === z ? mt : Ve(e), r = (n, o = {}) => {
    const { equalityFn: s = Or } = typeof o == "function" ? { equalityFn: o } : o;
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof s != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const i = t(), { store: a, subscription: u, getServerState: f } = i, c = x.useRef(!0), l = x.useCallback(
      {
        [n.name](h) {
          const _ = n(h);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: O = {} } = typeof o == "function" ? {} : o, { identityFunctionCheck: b, stabilityCheck: v } = i, {
              identityFunctionCheck: d,
              stabilityCheck: p
            } = {
              stabilityCheck: v,
              identityFunctionCheck: b,
              ...O
            };
            if (p === "always" || p === "once" && c.current) {
              const y = n(h);
              if (!s(_, y)) {
                let g;
                try {
                  throw new Error();
                } catch (E) {
                  ({ stack: g } = E);
                }
                console.warn(
                  "Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: h,
                    selected: _,
                    selected2: y,
                    stack: g
                  }
                );
              }
            }
            if ((d === "always" || d === "once" && c.current) && _ === h) {
              let y;
              try {
                throw new Error();
              } catch (g) {
                ({ stack: y } = g);
              }
              console.warn(
                "Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: y }
              );
            }
            c.current && (c.current = !1);
          }
          return _;
        }
      }[n.name],
      [n]
    ), m = sr.useSyncExternalStoreWithSelector(
      u.addNestedSub,
      a.getState,
      f || a.getState,
      l,
      s
    );
    return x.useDebugValue(m), m;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Jn = /* @__PURE__ */ Nr();
function re(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? re = function(r) {
    return typeof r;
  } : re = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, re(e);
}
function Sr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dr(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Pr(e, t, r) {
  return Dr(e.prototype, t), e;
}
function kr(e, t) {
  return t && (re(t) === "object" || typeof t == "function") ? t : ne(e);
}
function Se(e) {
  return Se = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Se(e);
}
function ne(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && De(e, t);
}
function De(e, t) {
  return De = Object.setPrototypeOf || function(n, o) {
    return n.__proto__ = o, n;
  }, De(e, t);
}
function oe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var gt = /* @__PURE__ */ function(e) {
  xr(t, e);
  function t() {
    var r, n;
    Sr(this, t);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return n = kr(this, (r = Se(t)).call.apply(r, [this].concat(s))), oe(ne(n), "state", {
      bootstrapped: !1
    }), oe(ne(n), "_unsubscribe", void 0), oe(ne(n), "handlePersistorState", function() {
      var a = n.props.persistor, u = a.getState(), f = u.bootstrapped;
      f && (n.props.onBeforeLift ? Promise.resolve(n.props.onBeforeLift()).finally(function() {
        return n.setState({
          bootstrapped: !0
        });
      }) : n.setState({
        bootstrapped: !0
      }), n._unsubscribe && n._unsubscribe());
    }), n;
  }
  return Pr(t, [{
    key: "componentDidMount",
    value: function() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState), this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function() {
      return process.env.NODE_ENV !== "production" && typeof this.props.children == "function" && this.props.loading && console.error("redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored."), typeof this.props.children == "function" ? this.props.children(this.state.bootstrapped) : this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]), t;
}(Ut);
oe(gt, "defaultProps", {
  children: null,
  loading: null
});
var Me = "persist:", wt = "persist/FLUSH", Ie = "persist/REHYDRATE", Et = "persist/PAUSE", vt = "persist/PERSIST", _t = "persist/PURGE", Ot = "persist/REGISTER", Tr = -1;
function Y(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Y = function(r) {
    return typeof r;
  } : Y = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Y(e);
}
function qe(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qe(r, !0).forEach(function(n) {
      Rr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qe(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rr(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ar(e, t, r, n) {
  var o = n.debug, s = Cr({}, r);
  return e && Y(e) === "object" && Object.keys(e).forEach(function(i) {
    if (i !== "_persist") {
      if (t[i] !== r[i]) {
        process.env.NODE_ENV !== "production" && o && console.log("redux-persist/stateReconciler: sub state for key `%s` modified, skipping.", i);
        return;
      }
      s[i] = e[i];
    }
  }), process.env.NODE_ENV !== "production" && o && e && Y(e) === "object" && console.log("redux-persist/stateReconciler: rehydrated keys '".concat(Object.keys(e).join(", "), "'")), s;
}
function jr(e) {
  var t = e.blacklist || null, r = e.whitelist || null, n = e.transforms || [], o = e.throttle || 0, s = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : Me).concat(e.key), i = e.storage, a;
  e.serialize === !1 ? a = function(g) {
    return g;
  } : typeof e.serialize == "function" ? a = e.serialize : a = Vr;
  var u = e.writeFailHandler || null, f = {}, c = {}, l = [], m = null, h = null, _ = function(g) {
    Object.keys(g).forEach(function(E) {
      v(E) && f[E] !== g[E] && l.indexOf(E) === -1 && l.push(E);
    }), Object.keys(f).forEach(function(E) {
      g[E] === void 0 && v(E) && l.indexOf(E) === -1 && f[E] !== void 0 && l.push(E);
    }), m === null && (m = setInterval(O, o)), f = g;
  };
  function O() {
    if (l.length === 0) {
      m && clearInterval(m), m = null;
      return;
    }
    var y = l.shift(), g = n.reduce(function(E, w) {
      return w.in(E, y, f);
    }, f[y]);
    if (g !== void 0)
      try {
        c[y] = a(g);
      } catch (E) {
        console.error("redux-persist/createPersistoid: error serializing state", E);
      }
    else
      delete c[y];
    l.length === 0 && b();
  }
  function b() {
    Object.keys(c).forEach(function(y) {
      f[y] === void 0 && delete c[y];
    }), h = i.setItem(s, a(c)).catch(d);
  }
  function v(y) {
    return !(r && r.indexOf(y) === -1 && y !== "_persist" || t && t.indexOf(y) !== -1);
  }
  function d(y) {
    u && u(y), y && process.env.NODE_ENV !== "production" && console.error("Error storing data", y);
  }
  var p = function() {
    for (; l.length !== 0; )
      O();
    return h || Promise.resolve();
  };
  return {
    update: _,
    flush: p
  };
}
function Vr(e) {
  return JSON.stringify(e);
}
function Mr(e) {
  var t = e.transforms || [], r = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : Me).concat(e.key), n = e.storage, o = e.debug, s;
  return e.deserialize === !1 ? s = function(a) {
    return a;
  } : typeof e.deserialize == "function" ? s = e.deserialize : s = Ir, n.getItem(r).then(function(i) {
    if (i) try {
      var a = {}, u = s(i);
      return Object.keys(u).forEach(function(f) {
        a[f] = t.reduceRight(function(c, l) {
          return l.out(c, f, u);
        }, s(u[f]));
      }), a;
    } catch (f) {
      throw process.env.NODE_ENV !== "production" && o && console.log("redux-persist/getStoredState: Error restoring data ".concat(i), f), f;
    }
    else
      return;
  });
}
function Ir(e) {
  return JSON.parse(e);
}
function zr(e) {
  var t = e.storage, r = "".concat(e.keyPrefix !== void 0 ? e.keyPrefix : Me).concat(e.key);
  return t.removeItem(r, $r);
}
function $r(e) {
  e && process.env.NODE_ENV !== "production" && console.error("redux-persist/purgeStoredState: Error purging data stored state", e);
}
function Je(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function V(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Je(r, !0).forEach(function(n) {
      Lr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Je(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lr(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fr(e, t) {
  if (e == null) return {};
  var r = Ur(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (o = 0; o < s.length; o++)
      n = s[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ur(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, s;
  for (s = 0; s < n.length; s++)
    o = n[s], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var Hr = 5e3;
function Xn(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (!e) throw new Error("config is required for persistReducer");
    if (!e.key) throw new Error("key is required in persistor config");
    if (!e.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }
  var r = e.version !== void 0 ? e.version : Tr;
  e.debug;
  var n = e.stateReconciler === void 0 ? Ar : e.stateReconciler, o = e.getStoredState || Mr, s = e.timeout !== void 0 ? e.timeout : Hr, i = null, a = !1, u = !0, f = function(l) {
    return l._persist.rehydrated && i && !u && i.update(l), l;
  };
  return function(c, l) {
    var m = c || {}, h = m._persist, _ = Fr(m, ["_persist"]), O = _;
    if (l.type === vt) {
      var b = !1, v = function(N, S) {
        process.env.NODE_ENV !== "production" && b && console.error('redux-persist: rehydrate for "'.concat(e.key, '" called after timeout.'), N, S), b || (l.rehydrate(e.key, N, S), b = !0);
      };
      if (s && setTimeout(function() {
        !b && v(void 0, new Error('redux-persist: persist timed out for persist key "'.concat(e.key, '"')));
      }, s), u = !1, i || (i = jr(e)), h)
        return V({}, t(O, l), {
          _persist: h
        });
      if (typeof l.rehydrate != "function" || typeof l.register != "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
      return l.register(e.key), o(e).then(function(w) {
        var N = e.migrate || function(S, R) {
          return Promise.resolve(S);
        };
        N(w, r).then(function(S) {
          v(S);
        }, function(S) {
          process.env.NODE_ENV !== "production" && S && console.error("redux-persist: migration error", S), v(void 0, S);
        });
      }, function(w) {
        v(void 0, w);
      }), V({}, t(O, l), {
        _persist: {
          version: r,
          rehydrated: !1
        }
      });
    } else {
      if (l.type === _t)
        return a = !0, l.result(zr(e)), V({}, t(O, l), {
          _persist: h
        });
      if (l.type === wt)
        return l.result(i && i.flush()), V({}, t(O, l), {
          _persist: h
        });
      if (l.type === Et)
        u = !0;
      else if (l.type === Ie) {
        if (a) return V({}, O, {
          _persist: V({}, h, {
            rehydrated: !0
          })
          // @NOTE if key does not match, will continue to default else below
        });
        if (l.key === e.key) {
          var d = t(O, l), p = l.payload, y = n !== !1 && p !== void 0 ? n(p, c, d, e) : d, g = V({}, y, {
            _persist: V({}, h, {
              rehydrated: !0
            })
          });
          return f(g);
        }
      }
    }
    if (!h) return t(c, l);
    var E = t(O, l);
    return E === O ? c : f(V({}, E, {
      _persist: h
    }));
  };
}
function P(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Br = typeof Symbol == "function" && Symbol.observable || "@@observable", Xe = Br, we = () => Math.random().toString(36).substring(7).split("").join("."), Wr = {
  INIT: `@@redux/INIT${/* @__PURE__ */ we()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ we()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${we()}`
}, L = Wr;
function X(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function Kr(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (qr(e))
    return "date";
  if (Yr(e))
    return "error";
  const r = Gr(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function Gr(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Yr(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function qr(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function I(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Kr(e)), t;
}
function ze(e, t, r) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? P(2) : `Expected the root reducer to be a function. Instead, received: '${I(e)}'`);
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? P(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? P(1) : `Expected the enhancer to be a function. Instead, received: '${I(r)}'`);
    return r(ze)(e, t);
  }
  let n = e, o = t, s = /* @__PURE__ */ new Map(), i = s, a = 0, u = !1;
  function f() {
    i === s && (i = /* @__PURE__ */ new Map(), s.forEach((b, v) => {
      i.set(v, b);
    }));
  }
  function c() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? P(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function l(b) {
    if (typeof b != "function")
      throw new Error(process.env.NODE_ENV === "production" ? P(4) : `Expected the listener to be a function. Instead, received: '${I(b)}'`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? P(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let v = !0;
    f();
    const d = a++;
    return i.set(d, b), function() {
      if (v) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? P(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        v = !1, f(), i.delete(d), s = null;
      }
    };
  }
  function m(b) {
    if (!X(b))
      throw new Error(process.env.NODE_ENV === "production" ? P(7) : `Actions must be plain objects. Instead, the actual type was: '${I(b)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof b.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? P(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof b.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? P(17) : `Action "type" property must be a string. Instead, the actual type was: '${I(b.type)}'. Value was: '${b.type}' (stringified)`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? P(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, o = n(o, b);
    } finally {
      u = !1;
    }
    return (s = i).forEach((d) => {
      d();
    }), b;
  }
  function h(b) {
    if (typeof b != "function")
      throw new Error(process.env.NODE_ENV === "production" ? P(10) : `Expected the nextReducer to be a function. Instead, received: '${I(b)}`);
    n = b, m({
      type: L.REPLACE
    });
  }
  function _() {
    const b = l;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(v) {
        if (typeof v != "object" || v === null)
          throw new Error(process.env.NODE_ENV === "production" ? P(11) : `Expected the observer to be an object. Instead, received: '${I(v)}'`);
        function d() {
          const y = v;
          y.next && y.next(c());
        }
        return d(), {
          unsubscribe: b(d)
        };
      },
      [Xe]() {
        return this;
      }
    };
  }
  return m({
    type: L.INIT
  }), {
    dispatch: m,
    subscribe: l,
    getState: c,
    replaceReducer: h,
    [Xe]: _
  };
}
function Qe(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Jr(e, t, r, n) {
  const o = Object.keys(t), s = r && r.type === L.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (o.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!X(e))
    return `The ${s} has unexpected type of "${I(e)}". Expected argument to be an object with the following keys: "${o.join('", "')}"`;
  const i = Object.keys(e).filter((a) => !t.hasOwnProperty(a) && !n[a]);
  if (i.forEach((a) => {
    n[a] = !0;
  }), !(r && r.type === L.REPLACE) && i.length > 0)
    return `Unexpected ${i.length > 1 ? "keys" : "key"} "${i.join('", "')}" found in ${s}. Expected to find one of the known reducer keys instead: "${o.join('", "')}". Unexpected keys will be ignored.`;
}
function Xr(e) {
  Object.keys(e).forEach((t) => {
    const r = e[t];
    if (typeof r(void 0, {
      type: L.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? P(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: L.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? P(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${L.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function Qr(e) {
  const t = Object.keys(e), r = {};
  for (let i = 0; i < t.length; i++) {
    const a = t[i];
    process.env.NODE_ENV !== "production" && typeof e[a] > "u" && Qe(`No reducer provided for key "${a}"`), typeof e[a] == "function" && (r[a] = e[a]);
  }
  const n = Object.keys(r);
  let o;
  process.env.NODE_ENV !== "production" && (o = {});
  let s;
  try {
    Xr(r);
  } catch (i) {
    s = i;
  }
  return function(a = {}, u) {
    if (s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      const l = Jr(a, r, u, o);
      l && Qe(l);
    }
    let f = !1;
    const c = {};
    for (let l = 0; l < n.length; l++) {
      const m = n[l], h = r[m], _ = a[m], O = h(_, u);
      if (typeof O > "u") {
        const b = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? P(14) : `When called with an action of type ${b ? `"${String(b)}"` : "(unknown type)"}, the slice reducer for key "${m}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      c[m] = O, f = f || O !== _;
    }
    return f = f || n.length !== Object.keys(a).length, f ? c : a;
  };
}
function ae(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, r) => (...n) => t(r(...n)));
}
function Zr(...e) {
  return (t) => (r, n) => {
    const o = t(r, n);
    let s = () => {
      throw new Error(process.env.NODE_ENV === "production" ? P(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const i = {
      getState: o.getState,
      dispatch: (u, ...f) => s(u, ...f)
    }, a = e.map((u) => u(i));
    return s = ae(...a)(o.dispatch), {
      ...o,
      dispatch: s
    };
  };
}
function Nt(e) {
  return X(e) && "type" in e && typeof e.type == "string";
}
function Ze(e) {
  return rn(e) || tn(e) || en();
}
function en() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function tn(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]") return Array.from(e);
}
function rn(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = new Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  }
}
function et(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? et(r, !0).forEach(function(n) {
      nn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : et(r).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nn(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var St = {
  registry: [],
  bootstrapped: !1
}, on = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : St, r = arguments.length > 1 ? arguments[1] : void 0;
  switch (r.type) {
    case Ot:
      return Pe({}, t, {
        registry: [].concat(Ze(t.registry), [r.key])
      });
    case Ie:
      var n = t.registry.indexOf(r.key), o = Ze(t.registry);
      return o.splice(n, 1), Pe({}, t, {
        registry: o,
        bootstrapped: o.length === 0
      });
    default:
      return t;
  }
};
function sn(e, t, r) {
  if (process.env.NODE_ENV !== "production") {
    var n = {}, o = ["blacklist", "whitelist", "transforms", "storage", "keyPrefix", "migrate"];
    o.forEach(function(f) {
      n[f] && console.error('redux-persist: invalid option passed to persistStore: "'.concat(f, '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.'));
    });
  }
  var s = ze(on, St, void 0), i = function(c) {
    s.dispatch({
      type: Ot,
      key: c
    });
  }, a = function(c, l, m) {
    var h = {
      type: Ie,
      payload: l,
      err: m,
      key: c
      // dispatch to `store` to rehydrate and `persistor` to track result
    };
    e.dispatch(h), s.dispatch(h);
  }, u = Pe({}, s, {
    purge: function() {
      var c = [];
      return e.dispatch({
        type: _t,
        result: function(m) {
          c.push(m);
        }
      }), Promise.all(c);
    },
    flush: function() {
      var c = [];
      return e.dispatch({
        type: wt,
        result: function(m) {
          c.push(m);
        }
      }), Promise.all(c);
    },
    pause: function() {
      e.dispatch({
        type: Et
      });
    },
    persist: function() {
      e.dispatch({
        type: vt,
        register: i,
        rehydrate: a
      });
    }
  });
  return u.persist(), u;
}
function Qn(e) {
  return /* @__PURE__ */ Fe(Er, { ...e, children: /* @__PURE__ */ Fe(
    gt,
    {
      persistor: sn(e.store),
      loading: e.loading,
      children: e.children
    }
  ) });
}
var Dt = Symbol.for("immer-nothing"), tt = Symbol.for("immer-draftable"), T = Symbol.for("immer-state"), an = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function k(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = an[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var K = Object.getPrototypeOf;
function F(e) {
  return !!e && !!e[T];
}
function M(e) {
  return e ? Pt(e) || Array.isArray(e) || !!e[tt] || !!e.constructor?.[tt] || de(e) || pe(e) : !1;
}
var un = Object.prototype.constructor.toString();
function Pt(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = K(e);
  if (t === null)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === un;
}
function ue(e, t) {
  le(e) === 0 ? Reflect.ownKeys(e).forEach((r) => {
    t(r, e[r], e);
  }) : e.forEach((r, n) => t(n, r, e));
}
function le(e) {
  const t = e[T];
  return t ? t.type_ : Array.isArray(e) ? 1 : de(e) ? 2 : pe(e) ? 3 : 0;
}
function ke(e, t) {
  return le(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function kt(e, t, r) {
  const n = le(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function cn(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function de(e) {
  return e instanceof Map;
}
function pe(e) {
  return e instanceof Set;
}
function $(e) {
  return e.copy_ || e.base_;
}
function xe(e, t) {
  if (de(e))
    return new Map(e);
  if (pe(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Pt(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[T];
    let o = Reflect.ownKeys(n);
    for (let s = 0; s < o.length; s++) {
      const i = o[s], a = n[i];
      a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (n[i] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: a.enumerable,
        value: e[i]
      });
    }
    return Object.create(K(e), n);
  } else {
    const n = K(e);
    if (n !== null && r)
      return { ...e };
    const o = Object.create(n);
    return Object.assign(o, e);
  }
}
function $e(e, t = !1) {
  return he(e) || F(e) || !M(e) || (le(e) > 1 && (e.set = e.add = e.clear = e.delete = fn), Object.freeze(e), t && Object.entries(e).forEach(([r, n]) => $e(n, !0))), e;
}
function fn() {
  k(2);
}
function he(e) {
  return Object.isFrozen(e);
}
var ln = {};
function U(e) {
  const t = ln[e];
  return t || k(0, e), t;
}
var q;
function xt() {
  return q;
}
function dn(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function rt(e, t) {
  t && (U("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Te(e) {
  Ce(e), e.drafts_.forEach(pn), e.drafts_ = null;
}
function Ce(e) {
  e === q && (q = e.parent_);
}
function nt(e) {
  return q = dn(q, e);
}
function pn(e) {
  const t = e[T];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function ot(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[T].modified_ && (Te(t), k(4)), M(e) && (e = ce(t, e), t.parent_ || fe(t, e)), t.patches_ && U("Patches").generateReplacementPatches_(
    r[T].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = ce(t, r, []), Te(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Dt ? e : void 0;
}
function ce(e, t, r) {
  if (he(t))
    return t;
  const n = t[T];
  if (!n)
    return ue(
      t,
      (o, s) => it(e, n, t, o, s, r)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return fe(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const o = n.copy_;
    let s = o, i = !1;
    n.type_ === 3 && (s = new Set(o), o.clear(), i = !0), ue(
      s,
      (a, u) => it(e, n, o, a, u, r, i)
    ), fe(e, o, !1), r && e.patches_ && U("Patches").generatePatches_(
      n,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function it(e, t, r, n, o, s, i) {
  if (process.env.NODE_ENV !== "production" && o === r && k(5), F(o)) {
    const a = s && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ke(t.assigned_, n) ? s.concat(n) : void 0, u = ce(e, o, a);
    if (kt(r, n, u), F(u))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else i && r.add(o);
  if (M(o) && !he(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    ce(e, o), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && fe(e, o);
  }
}
function fe(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && $e(t, r);
}
function hn(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : xt(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = n, s = Le;
  r && (o = [n], s = J);
  const { revoke: i, proxy: a } = Proxy.revocable(o, s);
  return n.draft_ = a, n.revoke_ = i, a;
}
var Le = {
  get(e, t) {
    if (t === T)
      return e;
    const r = $(e);
    if (!ke(r, t))
      return yn(e, r, t);
    const n = r[t];
    return e.finalized_ || !M(n) ? n : n === Ee(e.base_, t) ? (ve(e), e.copy_[t] = Ae(n, e)) : n;
  },
  has(e, t) {
    return t in $(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys($(e));
  },
  set(e, t, r) {
    const n = Tt($(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const o = Ee($(e), t), s = o?.[T];
      if (s && s.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (cn(r, o) && (r !== void 0 || ke(e.base_, t)))
        return !0;
      ve(e), Re(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ee(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, ve(e), Re(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = $(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    k(11);
  },
  getPrototypeOf(e) {
    return K(e.base_);
  },
  setPrototypeOf() {
    k(12);
  }
}, J = {};
ue(Le, (e, t) => {
  J[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
J.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && k(13), J.set.call(this, e, t, void 0);
};
J.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && k(14), Le.set.call(this, e[0], t, r, e[0]);
};
function Ee(e, t) {
  const r = e[T];
  return (r ? $(r) : e)[t];
}
function yn(e, t, r) {
  const n = Tt(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function Tt(e, t) {
  if (!(t in e))
    return;
  let r = K(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = K(r);
  }
}
function Re(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Re(e.parent_));
}
function ve(e) {
  e.copy_ || (e.copy_ = xe(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var mn = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const s = r;
        r = t;
        const i = this;
        return function(u = s, ...f) {
          return i.produce(u, (c) => r.call(this, c, ...f));
        };
      }
      typeof r != "function" && k(6), n !== void 0 && typeof n != "function" && k(7);
      let o;
      if (M(t)) {
        const s = nt(this), i = Ae(t, void 0);
        let a = !0;
        try {
          o = r(i), a = !1;
        } finally {
          a ? Te(s) : Ce(s);
        }
        return rt(s, n), ot(o, s);
      } else if (!t || typeof t != "object") {
        if (o = r(t), o === void 0 && (o = t), o === Dt && (o = void 0), this.autoFreeze_ && $e(o, !0), n) {
          const s = [], i = [];
          U("Patches").generateReplacementPatches_(t, o, s, i), n(s, i);
        }
        return o;
      } else
        k(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (i, ...a) => this.produceWithPatches(i, (u) => t(u, ...a));
      let n, o;
      return [this.produce(t, r, (i, a) => {
        n = i, o = a;
      }), n, o];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    M(e) || k(8), F(e) && (e = bn(e));
    const t = nt(this), r = Ae(e, void 0);
    return r[T].isManual_ = !0, Ce(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[T];
    (!r || !r.isManual_) && k(9);
    const { scope_: n } = r;
    return rt(n, t), ot(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const o = t[r];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = U("Patches").applyPatches_;
    return F(e) ? n(e, t) : this.produce(
      e,
      (o) => n(o, t)
    );
  }
};
function Ae(e, t) {
  const r = de(e) ? U("MapSet").proxyMap_(e, t) : pe(e) ? U("MapSet").proxySet_(e, t) : hn(e, t);
  return (t ? t.scope_ : xt()).drafts_.push(r), r;
}
function bn(e) {
  return F(e) || k(10, e), Ct(e);
}
function Ct(e) {
  if (!M(e) || he(e))
    return e;
  const t = e[T];
  let r;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = xe(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    r = xe(e, !0);
  return ue(r, (n, o) => {
    kt(r, n, Ct(o));
  }), t && (t.finalized_ = !1), r;
}
var C = new mn(), Rt = C.produce;
C.produceWithPatches.bind(
  C
);
C.setAutoFreeze.bind(C);
C.setUseStrictShallowCopy.bind(C);
C.applyPatches.bind(C);
C.createDraft.bind(C);
C.finishDraft.bind(C);
function At(e) {
  return ({ dispatch: r, getState: n }) => (o) => (s) => typeof s == "function" ? s(r, n, e) : o(s);
}
var gn = At(), wn = At, En = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? ae : ae.apply(null, arguments);
}, vn = (e) => e && typeof e.match == "function";
function st(e, t) {
  function r(...n) {
    if (t) {
      let o = t(...n);
      if (!o)
        throw new Error(process.env.NODE_ENV === "production" ? D(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: o.payload,
        ..."meta" in o && {
          meta: o.meta
        },
        ..."error" in o && {
          error: o.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => Nt(n) && n.type === e, r;
}
function _n(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  vn(e);
}
function On(e) {
  const t = e ? `${e}`.split("/") : [], r = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`;
}
function Nn(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (r) => (n) => r(n);
  const {
    isActionCreator: t = _n
  } = e;
  return () => (r) => (n) => (t(n) && console.warn(On(n.type)), r(n));
}
function jt(e, t) {
  let r = 0;
  return {
    measureTime(n) {
      const o = Date.now();
      try {
        return n();
      } finally {
        const s = Date.now();
        r += s - o;
      }
    },
    warnIfExceeded() {
      r > e && console.warn(`${t} took ${r}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var Vt = class G extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, G.prototype);
  }
  static get [Symbol.species]() {
    return G;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new G(...t[0].concat(this)) : new G(...t.concat(this));
  }
};
function at(e) {
  return M(e) ? Rt(e, () => {
  }) : e;
}
function ut(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Sn(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Dn(e, t, r) {
  const n = Mt(e, t, r);
  return {
    detectMutations() {
      return It(e, t, n, r);
    }
  };
}
function Mt(e, t = [], r, n = "", o = /* @__PURE__ */ new Set()) {
  const s = {
    value: r
  };
  if (!e(r) && !o.has(r)) {
    o.add(r), s.children = {};
    for (const i in r) {
      const a = n ? n + "." + i : i;
      t.length && t.indexOf(a) !== -1 || (s.children[i] = Mt(e, t, r[i], a));
    }
  }
  return s;
}
function It(e, t = [], r, n, o = !1, s = "") {
  const i = r ? r.value : void 0, a = i === n;
  if (o && !a && !Number.isNaN(n))
    return {
      wasMutated: !0,
      path: s
    };
  if (e(i) || e(n))
    return {
      wasMutated: !1
    };
  const u = {};
  for (let c in r.children)
    u[c] = !0;
  for (let c in n)
    u[c] = !0;
  const f = t.length > 0;
  for (let c in u) {
    const l = s ? s + "." + c : c;
    if (f && t.some((_) => _ instanceof RegExp ? _.test(l) : l === _))
      continue;
    const m = It(e, t, r.children[c], n[c], a, l);
    if (m.wasMutated)
      return m;
  }
  return {
    wasMutated: !1
  };
}
function Pn(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    let t = function(a, u, f, c) {
      return JSON.stringify(a, r(u, c), f);
    }, r = function(a, u) {
      let f = [], c = [];
      return u || (u = function(l, m) {
        return f[0] === m ? "[Circular ~]" : "[Circular ~." + c.slice(0, f.indexOf(m)).join(".") + "]";
      }), function(l, m) {
        if (f.length > 0) {
          var h = f.indexOf(this);
          ~h ? f.splice(h + 1) : f.push(this), ~h ? c.splice(h, 1 / 0, l) : c.push(l), ~f.indexOf(m) && (m = u.call(this, l, m));
        } else f.push(m);
        return a == null ? m : a.call(this, l, m);
      };
    }, {
      isImmutable: n = Sn,
      ignoredPaths: o,
      warnAfter: s = 32
    } = e;
    const i = Dn.bind(null, n, o);
    return ({
      getState: a
    }) => {
      let u = a(), f = i(u), c;
      return (l) => (m) => {
        const h = jt(s, "ImmutableStateInvariantMiddleware");
        h.measureTime(() => {
          if (u = a(), c = f.detectMutations(), f = i(u), c.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? D(19) : `A state mutation was detected between dispatches, in the path '${c.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const _ = l(m);
        return h.measureTime(() => {
          if (u = a(), c = f.detectMutations(), f = i(u), c.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? D(20) : `A state mutation was detected inside a dispatch, in the path: ${c.path || ""}. Take a look at the reducer(s) handling the action ${t(m)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), h.warnIfExceeded(), _;
      };
    };
  }
}
function zt(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || X(e);
}
function je(e, t = "", r = zt, n, o = [], s) {
  let i;
  if (!r(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || s?.has(e)) return !1;
  const a = n != null ? n(e) : Object.entries(e), u = o.length > 0;
  for (const [f, c] of a) {
    const l = t ? t + "." + f : f;
    if (!(u && o.some((h) => h instanceof RegExp ? h.test(l) : l === h))) {
      if (!r(c))
        return {
          keyPath: l,
          value: c
        };
      if (typeof c == "object" && (i = je(c, l, r, n, o, s), i))
        return i;
    }
  }
  return s && $t(e) && s.add(e), !1;
}
function $t(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !$t(t))
      return !1;
  return !0;
}
function kn(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    const {
      isSerializable: t = zt,
      getEntries: r,
      ignoredActions: n = [],
      ignoredActionPaths: o = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: s = [],
      warnAfter: i = 32,
      ignoreState: a = !1,
      ignoreActions: u = !1,
      disableCache: f = !1
    } = e, c = !f && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (l) => (m) => (h) => {
      if (!Nt(h))
        return m(h);
      const _ = m(h), O = jt(i, "SerializableStateInvariantMiddleware");
      return !u && !(n.length && n.indexOf(h.type) !== -1) && O.measureTime(() => {
        const b = je(h, "", t, r, o, c);
        if (b) {
          const {
            keyPath: v,
            value: d
          } = b;
          console.error(`A non-serializable value was detected in an action, in the path: \`${v}\`. Value:`, d, `
Take a look at the logic that dispatched this action: `, h, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), a || (O.measureTime(() => {
        const b = l.getState(), v = je(b, "", t, r, s, c);
        if (v) {
          const {
            keyPath: d,
            value: p
          } = v;
          console.error(`A non-serializable value was detected in the state, in the path: \`${d}\`. Value:`, p, `
Take a look at the reducer(s) handling this action type: ${h.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), O.warnIfExceeded()), _;
    };
  }
}
function Z(e) {
  return typeof e == "boolean";
}
var xn = () => function(t) {
  const {
    thunk: r = !0,
    immutableCheck: n = !0,
    serializableCheck: o = !0,
    actionCreatorCheck: s = !0
  } = t ?? {};
  let i = new Vt();
  if (r && (Z(r) ? i.push(gn) : i.push(wn(r.extraArgument))), process.env.NODE_ENV !== "production") {
    if (n) {
      let a = {};
      Z(n) || (a = n), i.unshift(Pn(a));
    }
    if (o) {
      let a = {};
      Z(o) || (a = o), i.push(kn(a));
    }
    if (s) {
      let a = {};
      Z(s) || (a = s), i.unshift(Nn(a));
    }
  }
  return i;
}, Tn = "RTK_autoBatch", ct = (e) => (t) => {
  setTimeout(t, e);
}, Cn = (e = {
  type: "raf"
}) => (t) => (...r) => {
  const n = t(...r);
  let o = !0, s = !1, i = !1;
  const a = /* @__PURE__ */ new Set(), u = e.type === "tick" ? queueMicrotask : e.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : ct(10)
  ) : e.type === "callback" ? e.queueNotification : ct(e.timeout), f = () => {
    i = !1, s && (s = !1, a.forEach((c) => c()));
  };
  return Object.assign({}, n, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(c) {
      const l = () => o && c(), m = n.subscribe(l);
      return a.add(c), () => {
        m(), a.delete(c);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(c) {
      try {
        return o = !c?.meta?.[Tn], s = !o, s && (i || (i = !0, u(f))), n.dispatch(c);
      } finally {
        o = !0;
      }
    }
  });
}, Rn = (e) => function(r) {
  const {
    autoBatch: n = !0
  } = r ?? {};
  let o = new Vt(e);
  return n && o.push(Cn(typeof n == "object" ? n : void 0)), o;
};
function Zn(e) {
  const t = xn(), {
    reducer: r = void 0,
    middleware: n,
    devTools: o = !0,
    preloadedState: s = void 0,
    enhancers: i = void 0
  } = e || {};
  let a;
  if (typeof r == "function")
    a = r;
  else if (X(r))
    a = Qr(r);
  else
    throw new Error(process.env.NODE_ENV === "production" ? D(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (process.env.NODE_ENV !== "production" && n && typeof n != "function")
    throw new Error(process.env.NODE_ENV === "production" ? D(2) : "`middleware` field must be a callback");
  let u;
  if (typeof n == "function") {
    if (u = n(t), process.env.NODE_ENV !== "production" && !Array.isArray(u))
      throw new Error(process.env.NODE_ENV === "production" ? D(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    u = t();
  if (process.env.NODE_ENV !== "production" && u.some((_) => typeof _ != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? D(4) : "each middleware provided to configureStore must be a function");
  let f = ae;
  o && (f = En({
    // Enable capture of stack traces for dispatched Redux actions
    trace: process.env.NODE_ENV !== "production",
    ...typeof o == "object" && o
  }));
  const c = Zr(...u), l = Rn(c);
  if (process.env.NODE_ENV !== "production" && i && typeof i != "function")
    throw new Error(process.env.NODE_ENV === "production" ? D(5) : "`enhancers` field must be a callback");
  let m = typeof i == "function" ? i(l) : l();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(m))
    throw new Error(process.env.NODE_ENV === "production" ? D(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && m.some((_) => typeof _ != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? D(7) : "each enhancer provided to configureStore must be a function");
  process.env.NODE_ENV !== "production" && u.length && !m.includes(c) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const h = f(...m);
  return ze(a, s, h);
}
function Lt(e) {
  const t = {}, r = [];
  let n;
  const o = {
    addCase(s, i) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? D(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? D(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const a = typeof s == "string" ? s : s.type;
      if (!a)
        throw new Error(process.env.NODE_ENV === "production" ? D(28) : "`builder.addCase` cannot be called with an empty action type");
      if (a in t)
        throw new Error(process.env.NODE_ENV === "production" ? D(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${a}'`);
      return t[a] = i, o;
    },
    addMatcher(s, i) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? D(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: s,
        reducer: i
      }), o;
    },
    addDefaultCase(s) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? D(31) : "`builder.addDefaultCase` can only be called once");
      return n = s, o;
    }
  };
  return e(o), [t, r, n];
}
function An(e) {
  return typeof e == "function";
}
function jn(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? D(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, o] = Lt(t), s;
  if (An(e))
    s = () => at(e());
  else {
    const a = at(e);
    s = () => a;
  }
  function i(a = s(), u) {
    let f = [r[u.type], ...n.filter(({
      matcher: c
    }) => c(u)).map(({
      reducer: c
    }) => c)];
    return f.filter((c) => !!c).length === 0 && (f = [o]), f.reduce((c, l) => {
      if (l)
        if (F(c)) {
          const h = l(c, u);
          return h === void 0 ? c : h;
        } else {
          if (M(c))
            return Rt(c, (m) => l(m, u));
          {
            const m = l(c, u);
            if (m === void 0) {
              if (c === null)
                return c;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return m;
          }
        }
      return c;
    }, a);
  }
  return i.getInitialState = s, i;
}
var Vn = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function Mn(e, t) {
  return `${e}/${t}`;
}
function In({
  creators: e
} = {}) {
  const t = e?.asyncThunk?.[Vn];
  return function(n) {
    const {
      name: o,
      reducerPath: s = o
    } = n;
    if (!o)
      throw new Error(process.env.NODE_ENV === "production" ? D(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const i = (typeof n.reducers == "function" ? n.reducers($n()) : n.reducers) || {}, a = Object.keys(i), u = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, f = {
      addCase(d, p) {
        const y = typeof d == "string" ? d : d.type;
        if (!y)
          throw new Error(process.env.NODE_ENV === "production" ? D(12) : "`context.addCase` cannot be called with an empty action type");
        if (y in u.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? D(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + y);
        return u.sliceCaseReducersByType[y] = p, f;
      },
      addMatcher(d, p) {
        return u.sliceMatchers.push({
          matcher: d,
          reducer: p
        }), f;
      },
      exposeAction(d, p) {
        return u.actionCreators[d] = p, f;
      },
      exposeCaseReducer(d, p) {
        return u.sliceCaseReducersByName[d] = p, f;
      }
    };
    a.forEach((d) => {
      const p = i[d], y = {
        reducerName: d,
        type: Mn(o, d),
        createNotation: typeof n.reducers == "function"
      };
      Fn(p) ? Hn(y, p, f, t) : Ln(y, p, f);
    });
    function c() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? D(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [d = {}, p = [], y = void 0] = typeof n.extraReducers == "function" ? Lt(n.extraReducers) : [n.extraReducers], g = {
        ...d,
        ...u.sliceCaseReducersByType
      };
      return jn(n.initialState, (E) => {
        for (let w in g)
          E.addCase(w, g[w]);
        for (let w of u.sliceMatchers)
          E.addMatcher(w.matcher, w.reducer);
        for (let w of p)
          E.addMatcher(w.matcher, w.reducer);
        y && E.addDefaultCase(y);
      });
    }
    const l = (d) => d, m = /* @__PURE__ */ new Map();
    let h;
    function _(d, p) {
      return h || (h = c()), h(d, p);
    }
    function O() {
      return h || (h = c()), h.getInitialState();
    }
    function b(d, p = !1) {
      function y(E) {
        let w = E[d];
        if (typeof w > "u") {
          if (p)
            w = O();
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? D(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return w;
      }
      function g(E = l) {
        const w = ut(m, p, () => /* @__PURE__ */ new WeakMap());
        return ut(w, E, () => {
          const N = {};
          for (const [S, R] of Object.entries(n.selectors ?? {}))
            N[S] = zn(R, E, O, p);
          return N;
        });
      }
      return {
        reducerPath: d,
        getSelectors: g,
        get selectors() {
          return g(y);
        },
        selectSlice: y
      };
    }
    const v = {
      name: o,
      reducer: _,
      actions: u.actionCreators,
      caseReducers: u.sliceCaseReducersByName,
      getInitialState: O,
      ...b(s),
      injectInto(d, {
        reducerPath: p,
        ...y
      } = {}) {
        const g = p ?? s;
        return d.inject({
          reducerPath: g,
          reducer: _
        }, y), {
          ...v,
          ...b(g, !0)
        };
      }
    };
    return v;
  };
}
function zn(e, t, r, n) {
  function o(s, ...i) {
    let a = t(s);
    if (typeof a > "u") {
      if (n)
        a = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? D(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(a, ...i);
  }
  return o.unwrapped = e, o;
}
var eo = /* @__PURE__ */ In();
function $n() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function Ln({
  type: e,
  reducerName: t,
  createNotation: r
}, n, o) {
  let s, i;
  if ("reducer" in n) {
    if (r && !Un(n))
      throw new Error(process.env.NODE_ENV === "production" ? D(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    s = n.reducer, i = n.prepare;
  } else
    s = n;
  o.addCase(e, s).exposeCaseReducer(t, s).exposeAction(t, i ? st(e, i) : st(e));
}
function Fn(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function Un(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Hn({
  type: e,
  reducerName: t
}, r, n, o) {
  if (!o)
    throw new Error(process.env.NODE_ENV === "production" ? D(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: s,
    fulfilled: i,
    pending: a,
    rejected: u,
    settled: f,
    options: c
  } = r, l = o(e, s, c);
  n.exposeAction(t, l), i && n.addCase(l.fulfilled, i), a && n.addCase(l.pending, a), u && n.addCase(l.rejected, u), f && n.addMatcher(l.settled, f), n.exposeCaseReducer(t, {
    fulfilled: i || ee,
    pending: a || ee,
    rejected: u || ee,
    settled: f || ee
  });
}
function ee() {
}
function D(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
export {
  Qn as Provider,
  Vt as Tuple,
  Qr as combineReducers,
  Zn as configureStore,
  eo as createSlice,
  Yn as history,
  Xn as persistReducer,
  qn as useDispatch,
  Jn as useSelector
};
